module.exports = "<span class=\"label label-danger\" ng-if=hasNewVersion>VORIGE VERSIE</span>; ";